import {buildCommonGridActionTypes} from "./commonGridATBuilder";
import {buildCommonEditorActionTypes} from "./commonEditorATBuider";

export const MEMBERSHIP_TYPES_GRID = buildCommonGridActionTypes('MEMBERSHIP_TYPES');

export const MEMBERSHIP_TYPES_EDITOR = buildCommonEditorActionTypes('MEMBERSHIP_TYPES');
